export default from './PhoneInput';



// WEBPACK FOOTER //
// ./src/sharedComponents/BuyerRegistrationForm/components/PhoneInput/index.js